import { CoreModel } from '../domain-models/core-model';
import { GenericServiceResponse } from './generic-service-response';
import { BaseIdentity } from '../domain-models/base-identity';

export class StoreResponse<TModel extends CoreModel<TIdentity>, TIdentity extends BaseIdentity> extends GenericServiceResponse<TModel> {

}
